.screen {
	min-height: 100%;
	padding: var(--space-5);
	padding-bottom: calc(var(--space-5) + 64px);
	max-width: var(--screen-max);
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	gap: var(--space-4);
}

.title {
	margin: 0;
	font-size: 1.05rem;
}

.intro {
	margin: 0;
	font-size: 0.85rem;
	color: var(--ink-muted);
}

.list {
	list-style: none;
	margin: 0;
	padding: 0;
	display: flex;
	flex-direction: column;
	gap: var(--space-2);
}

.empty {
	padding: var(--space-5) 0;
	margin: 0;
	color: var(--ink-muted);
	text-align: center;
}

.emptyLink {
	display: block;
	margin-top: var(--space-2);
	color: var(--accent-sage);
	text-decoration: underline;
}

.back {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border: none;
	background: none;
	border-radius: var(--radius-sm);
	color: var(--ink-muted);
	cursor: pointer;
}
